import { handleActions } from 'redux-actions'
import { setOptionsByBoatmodel } from './actions'

export const selection = handleActions({
  [setOptionsByBoatmodel]: (state, action) => ({
    ...state,
    ...action.payload
  })
}, {})
